<template>
  <div class="periodical">
    <div class="layer" :style="keywords || 'height:100vh'">
      <!-- 搜索部分 -->
      <div class="search-box width">
        <label>核心期刊名称</label>
        <el-input v-model="keyword" placeholder="请输入内容" style="width:20%;"></el-input>
        <el-select v-model="sort" placeholder="请选择" style="width: 140px;" @change="selectYear()">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-button
          type="primary"
          icon="el-icon-search"
          :disabled="!keyword"
          @click="getData()"
          style="background: #75867c;"
        >开始分析</el-button>
        <label style="maring-left:15%" v-if="Isnull">该期刊暂无数据</label>
      </div>
      <!-- 图表部分 -->
      <div class="search-box width" v-loading="loading1" v-if="!keyword">
        <h4>期刊导航</h4>
        <el-select
          v-model="letter"
          placeholder="根据字母筛选期刊"
          style="width: 160px;"
          @change="selectLetter"
        >
          <el-option
            v-for="item in letterOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <div v-for="(item,index) in journalList" :key="index" class="journal">
          <span v-if="index < 50" @click="clickJur(item.value)">{{item.value}}</span>
          <span v-if="index >= 50 && journalMore" @click="clickJur(item.value)">{{item.value}}</span>
        </div>
        <div
          class="more-btn"
          v-if="journalList.length>50"
          @click="more"
        >{{journalMore?'点击收起':'查看更多'}}</div>
      </div>
      <el-row class="periodical-box width" v-if="keywords">
        <el-col>
          <div class="nearyearbox segment htwo" v-loading="loading2">
            <div class="com-tit">{{keywords}}-近年学科排行</div>
            <div class="nearyear clearfix">
              <PieScienceChart
                style="-webkit-filter: saturate(0.5);filter: saturate(0.5);"
                class="fl"
                :PieScienceList="subjectList"
                id="NearYearChart"
                height="400px"
                width="70%"
                seriesName="发文篇数"
              />
              <div class="fl" style="width: 25%;">
                <el-button
                  @click="subjectClk(item.name)"
                  style="background: #f4f6f5;color: #97b4af;"
                  type="primary"
                  size="mini"
                  plain
                  v-for="(item,index) in subjectList"
                  :key="index"
                >{{item.name}}</el-button>
                <div class="tip">(点击可查看该学科核心期刊相关数据)</div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

      <div class="echarts-box width" :class="Isubject?'flex_column':'flex_row'" v-if="keywords">
        <div :class="!Isubject || 'flex_row'" :style="(!Isubject) ? 'width:49%':'width:100%'">
          <div
            class="ht450 echart-box"
            v-loading="loading2"
            :style="(Isubject) ? 'width:49%':'width:100%'"
          >
            <div class="com-tit">{{keywords}}-近年关键词</div>
            <wordcloud-Chart
              style="-webkit-filter: saturate(0.5);filter: saturate(0.5);"
              :isClick="isClick"
              id="EXPChart"
              :WordCloudList="keywordList1"
              height="400px"
              width="100%"
            />
          </div>
          <div
            class="ht450 echart-box"
            v-loading="loading3"
            v-if="Isubject"
            :style="(Isubject) ? 'width:49%':'width:100%'"
          >
            <div class="com-tit">{{subject}}-核心期刊近年关键词</div>
            <wordcloud-Chart
              style="-webkit-filter: saturate(0.5);filter: saturate(0.5);"
              id="EXPChart"
              :isClick="isClick"
              :WordCloudList="keywordList2"
              height="400px"
              width="100%"
            />
          </div>
        </div>
        <div :class="!Isubject || 'flex_row'" :style="(!Isubject) ? 'width:49%':'width:100%'">
          <div
            class="ht450 echart-box"
            v-loading="loading2"
            :style="(Isubject) ? 'width:49%':'width:100%'"
          >
            <div class="com-tit">{{keywords}}-近年发文量</div>
            <LineMaxMinChart
              style="-webkit-filter: saturate(0.5);filter: saturate(0.5);"
              tit="论文情况"
              class="line"
              id="HOTChart"
              height="400px"
              width="100%"
              :LineMaxMinList="postList1"
            />
          </div>
          <div
            class="ht450 echart-box"
            v-loading="loading3"
            v-if="Isubject"
            :style="(Isubject) ? 'width:49%':'width:100%'"
          >
            <div class="com-tit">{{subject}}-核心期刊近年发文量</div>
            <LineMaxMinChart
              style="-webkit-filter: saturate(0.5);filter: saturate(0.5);"
              tit="论文情况"
              class="line"
              id="HOTChart"
              height="400px"
              width="100%"
              :LineMaxMinList="postList2"
            />
          </div>
        </div>
        <div :class="!Isubject || 'flex_row'" :style="(!Isubject) ? 'width:49%':'width:100%'">
          <div
            class="ht65 echart-box"
            v-loading="loading2"
            :style="(Isubject) ? 'width:49%':'width:100%'"
          >
            <div class="com-tit">{{keywords}}-近年发文机构排行</div>
            <LinesChart
              id="EXPChart"
              :LinesList="instituteList1"
              :offset="140"
              height="90%"
              width="100%"
              style="-webkit-filter: saturate(0.5);filter: saturate(0.5);"
            />
          </div>
          <div
            class="ht65 echart-box"
            v-loading="loading3"
            v-if="Isubject"
            :style="(Isubject) ? 'width:49%':'width:100%'"
          >
            <div class="com-tit">{{subject}}-核心期刊近年发文机构排行</div>
            <LinesChart
              id="EXPChart"
              :LinesList="instituteList2"
              height="90%"
              width="100%"
              style="-webkit-filter: saturate(0.5);filter: saturate(0.5);"
            />
          </div>
        </div>
        <div :class="!Isubject || 'flex_row'" :style="(!Isubject) ? 'width:49%':'width:100%'">
          <div
            class="ht65 echart-box"
            v-loading="loading2"
            :style="(Isubject) ? 'width:49%':'width:100%'"
          >
            <div class="com-tit">{{keywords}}-近年高发文作者排行</div>
            <LinesChart
              id="EXPChart"
              :LinesList="creatorsList1"
              height="90%"
              width="100%"
              style="-webkit-filter:saturate(0.5);filter: saturate(0.5);"
            />
          </div>
          <div
            class="ht65 echart-box"
            v-loading="loading3"
            v-if="Isubject"
            :style="(Isubject) ? 'width:49%':'width:100%'"
          >
            <div class="com-tit">{{subject}}-核心期刊近年高发文作者排行</div>
            <LinesChart
              id="EXPChart"
              :LinesList="creatorsList2"
              height="90%"
              width="100%"
              style="-webkit-filter: saturate(0.5);filter: saturate(0.5);"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LineMaxMinChart from "@/components/Charts/LineMaxMinChart";
import LinesChart from "@/components/Charts/LinesChart";
import WordcloudChart from "@/components/Charts/WordcloudChart";
import PieScienceChart from "@/components/Charts/PieScienceChart";
import { queryJournalBySubject, queryJournalStats2 } from "@/api/perioducal";
import { getLetter } from "@/utils/index";

export default {
  name: "Keyword",
  components: {
    WordcloudChart,
    LineMaxMinChart,
    PieScienceChart,
    LinesChart
  },
  data() {
    return {
      keyword: this.$route.query.keyword || "", // 搜索参数
      keywords: "", // 是否显示图表
      options: [
        {
          value: 10,
          label: "近十年"
        },
        {
          value: 5,
          label: "近五年"
        },
        {
          value: 3,
          label: "近三年"
        }
      ],
      sort: 10,
      years: [], // 年数组
      letter: "", // 字母期刊
      subject: "", // 期刊
      letterOptions: [], // 字母期刊数组
      journalList: [], // 期刊数组
      subjectList: [], // 学科分布数组
      keywordList1: [], // 关键词数组
      postList1: [], // 论文发文数组
      instituteList1: {}, // 机构数组
      creatorsList1: {}, // 发文数组
      keywordList2: [], // 关键词数组
      postList2: [], // 论文发文数组
      instituteList2: {}, // 机构数组
      creatorsList2: {}, // 发文数组
      loading1: false, // 加载动画1
      loading2: false, // 加载动画2
      loading3: false, // 加载动画2
      journalMore: false, // 是否显示全部
      Isubject: false, // 是否点击subject
      Isnull: false, // 是否有数据
      isClick: true // 词云图是否有点击事件
    };
  },
  mounted() {
    // 26个字母
    for (var i = 0; i < 26; i++) {
      let temp = {
        value: String.fromCharCode(65 + i),
        label: String.fromCharCode(65 + i)
      };
      this.letterOptions.push(temp);
    }
    this.getYear(); // 年限组
    if (this.keyword) {
      this.getData();
    }
  },
  methods: {
    // 选择年份
    selectYear() {
      this.getYear();
    },
    // 设置年
    getYear() {
      this.years = [];
      let maxYear = new Date().getFullYear();
      for (let i = 0; i < this.sort; i++) {
        this.years.push(maxYear);
        maxYear--;
      }
    },
    //  点击期刊
    clickJur(val) {
      this.keyword = val;
      this.getData();
    },
    // 查看该学科核心期刊相关数据
    subjectClk(val) {
      this.Isubject = true;
      this.subject = val;
      this.getsubject(val);
    },
    // 获取数据
    getData() {
      this.Isubject = false;
      this.keywords = this.keyword;
      this.loading2 = true;
      this.postList1 = [];
      this.Isnull = false;
      let data = {
        from: 0,
        journal: this.keywords,
        size: 20,
        years: this.years
      };
      queryJournalStats2(data)
        .then(res => {
          this.loading2 = false;
          if (!res.years.length) {
            this.Isnull = true;
            this.keywords = "";
            return;
          }
          this.subjectList = res.subjects;
          this.keywordList1 = res.keywords;
          res.years.forEach((item, index) => {
            let temp = {
              key: item.name,
              doc_count: item.count
            };
            this.postList1.push(temp);
          });
          res.institutedata.newdata.series.forEach((item, index) => {
            res.institutedata.times[index] =
              res.institutedata.times[index] + "";
            item.data.forEach((temp, val) => {
              res.institutedata.newdata.series[index].data[val] =
                temp === 0 ? "" : temp;
            });
          });
          res.creatorsdata.newdata.series.forEach((item, index) => {
            res.creatorsdata.times[index] = res.creatorsdata.times[index] + "";
            item.data.forEach((temp, val) => {
              res.creatorsdata.newdata.series[index].data[val] =
                temp === 0 ? "" : temp;
            });
          });
          res.creatorsdata["info"] = res.creatorsdata.creators;
          this.instituteList1 = res.institutedata;
          this.creatorsList1 = res.creatorsdata;
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 查看该学科核心期刊相关数据
    getsubject(val) {
      this.loading3 = true;
      this.postList2 = [];
      let data = {
        from: 0,
        operate: 2,
        subject: val,
        size: 20,
        years: this.years
      };
      queryJournalStats2(data)
        .then(res => {
          this.loading3 = false;
          this.keywordList2 = res.keywords;
          res.years.forEach((item, index) => {
            let temp = {
              key: item.name,
              doc_count: item.count
            };
            this.postList2.push(temp);
          });
          res.institutedata.newdata.series.forEach((item, index) => {
            res.institutedata.times[index] =
              res.institutedata.times[index] + "";
            item.data.forEach((temp, val) => {
              res.institutedata.newdata.series[index].data[val] =
                temp === 0 ? "" : temp;
            });
          });
          res.creatorsdata.newdata.series.forEach((item, index) => {
            res.creatorsdata.times[index] = res.creatorsdata.times[index] + "";
            item.data.forEach((temp, val) => {
              res.creatorsdata.newdata.series[index].data[val] =
                temp === 0 ? "" : temp;
            });
          });
          res.creatorsdata["info"] = res.creatorsdata.creators;
          this.instituteList2 = res.institutedata;
          this.creatorsList2 = res.creatorsdata;
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 选择字母
    selectLetter() {
      this.loading1 = true;
      this.journalMore = false;
      let temp = getLetter(this.letter);
      let data = {
        letter: temp
      };
      // 根据字母返回期刊
      queryJournalBySubject(data)
        .then(res => {
          this.loading1 = false;
          this.journalList = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 显示更多
    more() {
      this.journalMore = !this.journalMore;
    }
  }
};
</script>

<style lang="scss">
.periodical {
  background-color: #f5f5f5;
  padding-top: 30px;
  .search-box {
    position: relative;
    border-top: 2px solid #0093dd;
    background: #ffffff;
    padding: 20px 40px;
    margin-bottom: 10px;
    h4 {
      margin-bottom: 5px;
    }
    .journal {
      margin-right: 0.5rem;
      display: inline-block;
      cursor: pointer;
      font-size: 0.875rem;
      line-height: 2rem;
    }
    .journal :hover {
      color: #0093dd;
    }
    .more-btn {
      font-size: 0.875rem;
      text-align: center;
      color: #0093dd;
      cursor: pointer;
    }
  }
  .periodical-box {
    .htwo {
      height: 450px;
    }
    .htle {
      height: 65em;
    }
    .segment {
      position: relative;
      border-top: 2px solid #0093dd;
      background: #ffffff;
      margin-bottom: 10px;
      text-align: center;
      .com-tit {
        display: inline-block;
        *display: inline;
        *zoom: 1;
        padding: 0 5rem;
        width: auto;
      }
    }
    .nearyearbox {
      .nearyear {
        padding: 10px;
        display: flex;
        .fl {
          margin: auto;
          float: left;
          text-align: left;
        }
        button {
          margin-left: 15px;
          margin-bottom: 15px;
        }
        .tip {
          font-size: 12px;
        }
      }
    }
  }
  .flex_row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .flex_column {
    display: flex;
    flex-direction: column;
  }
  .echarts-box {
    .ht450 {
      height: 450px;
    }
    .ht65 {
      height: 65em;
    }
    .echart-box {
      position: relative;
      border-top: 2px solid #0093dd;
      background: #ffffff;
      margin-bottom: 10px;
      text-align: center;
      .com-tit {
        display: inline-block;
        *display: inline;
        *zoom: 1;
        padding: 0 2rem;
        width: auto;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Periodical.vue